import React from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem } from 'reactstrap';
import { duzenlemeKuruluData} from './duzenlemeKuruluData'; // Veriyi import edin
import LeftBar from '../leftbar/LeftBar'


function DuzenlemeKurulu() {
    return (
        <Container>
            <div class="row my-4">
                <div class="col-md-9 kurullar">
                    <Row>
                        {duzenlemeKuruluData.map((team, teamIndex) => (
                            <Col key={teamIndex} md="12" className='my-2'>
                            
                                <ListGroup>
                                    {team.members.map((member, memberIndex) => (
                                        <ListGroupItem key={memberIndex}>
                                            {member.academicTitle} {member.firstName} {member.lastName}
                                        </ListGroupItem>
                                    ))}
                                </ListGroup>
                            </Col>
                        ))}
                    </Row>
                </div>
                <div class="col-md-3">
                    <LeftBar />
                </div>
            </div>
        </Container>
        
        
    );
}

export default DuzenlemeKurulu;
